import {postJson} from "@/ajax/http";
import {ApiUrl, ApiToken} from '@/config/sys.config'

export const chatApi = {
    stopChat: (taskId, data) => {
        let url = ApiUrl + `/chat-messages/${taskId}/stop`;
        let headers = {
            'Authorization': 'Bearer ' + ApiToken
        }
        return postJson(url, data, headers);
    },
    feedBackMessage:(messageid, rating, content,userId) => {
        const url = ApiUrl + "/messages/" + messageid + "/feedbacks";
        const data = {
            rating: rating,
            user: userId,
            content: content,
        };
        const options = {
            method: "POST",
            headers: {
                Authorization: "Bearer " + ApiToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        };
        fetch(url, options)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json(); // 将响应数据解析为 JSON 格式
            })
            .then((data) => {
                if (data.result === "success" && rating == "like") {
                    console.log("喜欢保存成功"); // 弹出调用成功的提示
                } else if (data.result === "success" && rating == "dislike") {
                    console.log("不喜欢保存成功"); // 弹出调用成功的提示
                }
            })
            .catch((error) => console.error("Error:", error));
    },

}
